import { retry } from './utils';

// eslint-disable-next-line import/prefer-default-export
export const loadCountries = (locale: any): Record<string, any> =>
  retry(() => import(`./countries/${locale}`).then((countries) => countries.default));
